module.exports = {
  audit_logs: 'Логи аудита',
  audit_logs_id: 'ID аудита',
  dt_action: 'Дата действия',
  request_id: 'ID запроса',
  user_id: 'ID пользователя',
  object_type: 'Тип объекта',
  object_id: 'ID объекта',
  action: 'Действие',
  action_success: 'Результат',
  username: 'Имя пользователя',
  user: 'Имя пользователя',
  object: 'Объект',
  user_request: 'Запрос пользователя',
  new_object_data: 'Новый объект',
  EDIT: 'Редактирование',
  DELETE: 'Удаление',
  CREATE: 'Создание',
  true: 'Успех',
  false: 'Провал',
};
